export const SESSION_INACTIVITY_TIMER_RESET = 'SESSION_INACTIVITY_TIMER_RESET';
export const SESSION_INACTIVITY_TIMER_STARTED = 'SESSION_INACTIVITY_TIMER_STARTED';
export const SESSION_RESET = 'SESSION_RESET';
export const SESSION_INACTIVITY_TIMEOUT_LIMIT_REACHED = 'SESSION_INACTIVITY_TIMEOUT_LIMIT_REACHED';
export const SESSION_EXPIRY_LIMIT_REACHED = 'SESSION_EXPIRY_LIMIT_REACHED';
export const SESSION_GET_ID = 'SESSION_GET_ID';
export const SESSION_SET_ID = 'SESSION_SET_ID';
export const SESSION_RESET_ID = 'SESSION_RESET_ID';